export var SENDING = 'SENDING';
export var SENT = 'SENT';
export var DELIVERED = 'DELIVERED';
export var READ = 'READ';
//# sourceMappingURL=MessageReceiptState.js.map
